// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CustomerReviews_wrapper__dVo_s"};